module.exports = __webpack_public_path__ + "static/img/商品轮播图@3x.e9f8bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/商品轮播图@3x.png
// module id = +zMF
// module chunks = 192